export default __webpack_public_path__ + "static/media/menu_farming.31216d1a.svg";